import moment from "moment";

const OrderService = {
    createOrder: async function (firstName, lastName, mail, phone, dateFrom, dateTo, items, services, placeOrder,
                                 address = null, city = null, zip = null,
                                 company_name = null, company_id = null, company_vat_id = null,
                                 customValues = null
                                 ) {
        const url = '/api/public/v1/order/create';
        const requestBody = {
            firstName: firstName,
            lastName: lastName,
            mail: mail,
            phone: phone,

            dateFrom: moment(dateFrom).format('YYYY-MM-DD'),
            dateTo: moment(dateTo).format('YYYY-MM-DD'),

            items: items,
            services: services,
            placeOrder: placeOrder,

            address: address,
            city: city,
            zip: zip,

            company_name: company_name,
            company_id: company_id,
            company_vat_id: company_vat_id
        };
        if (customValues && Object.keys(customValues).length > 0) {
            requestBody.customValues = customValues;
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            // if (!response.ok) {
            //     throw new Error('Network response was not ok');
            // }

            const responseData = await response.json();
            return responseData;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    },

    addToCart: async function (productsIdCsv, dateFrom, dateTo, quantity) {
        let urlApi = new URL(window.links.reservation.addToCartJson);
        urlApi.searchParams.append('dateFrom', dateFrom);
        urlApi.searchParams.append('dateTo', dateTo);
        urlApi.searchParams.append('productId', productsIdCsv);
        urlApi.searchParams.append('officeId', 1);
        const urlApiString = urlApi.toString();

        fetch(urlApiString, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    window.location.href = window.links.reservation.finish;
                } else {
                    alert(data.error);
                }
            });
    }
};


export default OrderService;